/**
 * This file is auto-generated from ChatEnd.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const chatEndedHeadline: Translation = lang => {
    switch (lang) {
        case 'en':
            return "That's a wrap — reach out anytime!";
        case 'pl':
            return 'To już wszystko — odezwij się, gdy będziesz potrzebować!';
    }
};

export const chatEndedCaption: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Chat ended';
        case 'pl':
            return 'Czat zakończony';
    }
};
